import {styled} from '@esgi/ui/theme';

export const Circle = styled('circle', {
	fill: 'none',
});
